const initialState = {
    search: '',
    category:'',
    author_name:'',
}

export default initialState;